import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import triggerEdapEvent from '../../utils/edap';

class CountrySelector extends Component {

    static propTypes = {
        title: PropTypes.string,
        countryCode: PropTypes.string,
        countries: PropTypes.arrayOf(
            PropTypes.shape({
                countryCode: PropTypes.string,
                countryName: PropTypes.string
            })
        ),
        onChange: PropTypes.func
    }

    static defaultProps = {
        title: 'Country',
        countryCode: 'jp',
        countries: [{countryCode: 'jp', countryName: '日本'}, {countryCode: 'us', countryName: 'United States'}],
        onChange: () => {}
    }

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.getCountryNameByCode(this.props.countryCode);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(countryCode) {
        this.getCountryNameByCode(countryCode);
        this.props.onChange(countryCode);
    }

    handleDropdownShow() {
        triggerEdapEvent({
            eventaction: 'display country dropdown clicked'
        });
    }

    getCountryNameByCode(countryCode) {
        let currentCountry = this.props.countries.filter((country) => {
            return country.countryCode === countryCode;
        })[0];
        this.countryName = currentCountry ? currentCountry.countryName : '';
    }

    render() {
        const {title, countryCode, countries} = this.props;
        return (
            <div className="preference-selector preference-selector--country form-group">
                <div className="preference-selector__title">{title}</div>
                <Dropdown
                    srOnlyLabel
                    label="Country Selector"
                    buttonChildren={
                        <span className="preference-selector__selected-option"><i className={`option-country-flag flag-${countryCode}`} aria-hidden />{this.countryName}</span>
                    }
                    id="country-selector"
                    name="country-selector"
                    onDropdownShow={this.handleDropdownShow}
                >
                    {countries.map((country) => {
                        return (
                            <DropdownItem
                                text={<a><i className={`option-country-flag flag-${country.countryCode}`} aria-hidden />{country.countryName}</a>}
                                key={country.countryCode}
                                onClick={() => this.handleChange(country.countryCode)} // eslint-disable-line react/jsx-no-bind
                            />
                        );
                    })}
                </Dropdown>
            </div>
        );
    }

}

export default CountrySelector;
